import React from "react";
// import { lazy } from 'react';

// project imports
import MainLayout from '../components/mainLayout/MainLayout';
// import Loadable from '../components/Loadable';

// dashboard routing
// const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));

// utilities routing
// const PasteText = Loadable(lazy(() => import('views/utilities/PasteText')));

// Inner page routing
// const About = Loadable(lazy(() => import('views/pages/authentication/About')));
// const PrivacyPolicy = Loadable(lazy(() => import('views/pages/authentication/PrivacyPolicy')));
// const Terms = Loadable(lazy(() => import('views/pages/authentication/Terms')));
// const ContactUs = Loadable(lazy(() => import('views/pages/authentication/ContactUs')));
// const MainBlog =  Loadable(lazy(() => import('views/pages/authentication/MainBlog')));
import Blog from "../pages/blogs/Blog";
import About from "../pages/About";
import Terms from "../pages/Terms";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import ContactUs from "../pages/ContactUs";
import PasteText from "../components/PasteText";
import PublishText from "../components/publishText";
// LinkPage removed
import LivePage from "../pages/LivePage";
import PreviewPage from "../pages/PreviewPage";
import DisclaimerPage from "../pages/Disclaimer";
import ShippingAndDeliveryPolicy from "../pages/ShippingAndDeliveryPolicy";
import CancellationAndRefundPolicy from "../pages/CancellationAndRefundPolicy";
// import AdminPanel from "../components/admin/AdminPanel";
import { Navigate } from "react-router-dom";
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
   { path: "/", element: <Navigate to="/pastetext" replace /> },
    {
      path: '/pastetext',
      element: <PasteText />
    },
    {
      path: '/publish',
      element: <PublishText />
    },
    {
      path: '/livePage',
      element: <LivePage />
    },
    {
      path: '/preview/:token',
      element: <PreviewPage />
    },
    {
      path: 'about-us',
      element: <About />
    },
    {
      path: 'blog/react-ssr-seo-react-helmet',
      element: <Blog />
    },
    {
      path: 'blog/tailwindcss',
      element: <Blog />
    },
    {
      path: 'blog/godaddy-hosting-web',
      element: <Blog />
    },
    {
      path: 'blog/importance-of-backlinks-justpaste',
      element: <Blog />
    },
    {
      path: 'blog/advanced-long-tail-keyword-optimization-seo-guide',
      element: <Blog />
    },
    {
      path: 'blog/secure-text-sharing-tools-remote-teams',
      element: <Blog />
    },
    {
      path: 'blog/free-qr-code-generator-text-sharing-mobile',
      element: <Blog />
    },
    {
      path: 'blog/free-online-text-editor-rich-formatting-guide',
      element: <Blog />
    },
    {
      path: 'blog/anonymous-text-publishing-platform-secure-content-sharing',
      element: <Blog />
    },
    {
      path: 'blog/code-snippet-sharing-syntax-highlighting-developers',
      element: <Blog />
    },
    {
      path: 'blog/best-pastebin-alternatives-dpaste-snippets-comparison',
      element: <Blog />
    },
    {
      path: 'blog/programmer-productivity-tools-code-sharing-collaboration',
      element: <Blog />
    },
    {
      path: 'blog/share-online-text-without-login',
      element: <Blog />
    },
    {
      path: 'blog/where-to-share-text-online',
      element: <Blog />
    },
    {
      path: 'blog/fast-note-sharing-instant-notepad-without-captcha',
      element: <Blog />
    },
    {
      path: '/terms',
      element: <Terms />
    },
    {
      path: '/privacypolicy',
      element: <PrivacyPolicy />
    },
    {
      path: '/disclaimer',
      element: <DisclaimerPage />
    },
    {
      path: '/contact-us',
      element: <ContactUs />
    },
    // {
    //   path: '/shop',
    //   element: <LinkPage />
    // },
    {
      path: '/delivery',
      element: <ShippingAndDeliveryPolicy />
    },
    {
      path: '/refund',
      element: <CancellationAndRefundPolicy />
    }
    // ,
    // {
    //   path: '/system-admin-access-2024',
    //   element: <AdminPanel />
    // }
  ]
};

export default MainRoutes;
